exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#device-listing-page-container{width:100%;padding:20px;background-color:#fff}#device-listing-page-container .device-listing-page-content{margin-bottom:50px}#device-listing-page-container .device-listing-page-content .origin-table-container{width:100%}#device-listing-page-container .device-listing-page-content .origin-table-header{width:100%;padding:10px;padding-bottom:0;display:flex;justify-content:space-between;transition:all .3s cubic-bezier(.215,.61,.355,1)}#device-listing-page-container .device-listing-page-content .add-device-btn{margin:15px;margin-top:0}#device-listing-page-container .device-listing-page-content .edit-cell button{width:80%;margin-left:10%}#device-listing-page-container .device-listing-page-content .delete-cell{width:100%;font-size:20px;color:red;text-align:center}#device-listing-page-container .device-listing-page-content .row{padding-top:5px;padding-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/settings/devices/listing.scss
// module id = 2176
// module chunks = 43